export default {
  edit_profile: 'Editar perfil',
  my_account: 'Mi cuenta',
  balance: 'Saldo',
  available_for_withdrawal: 'Disponible para retirar',
  amount_in_hold: 'Cantidad en espera',
  latest_news: 'Últimas noticias',
  more_news: 'Más noticias'
};